"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;
var _utils = require("../utils/utils");
// Logger class
// This class is used to log messages to the console
// It has a set of predefined levels and segments
// The levels are info, warn and error
// The segments are location, tagging, questionnaire, hooks, actions, selectors, reducers, sagas, services, utils and components
// The class has a set of methods to log messages to the console
// The methods are info, warn and error
// The info, warn and error methods are used to log messages with the corresponding level
//
// info, warn and error are higher order functions that return a function that logs messages to the console
// Usage: Logger.info({ segments: [Logger.LOGGER_SEGMENTS.LOCATION] })('message', 'message2', ...) -> logs a message with the info level
// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

class Logger {}
exports.Logger = Logger;
// Constants
Logger.levelColors = {
  error: 'red',
  warn: 'orange',
  info: '#4287f5'
};
Logger.LOGGER_SEGMENTS = {
  LOCATION: 'location',
  TAGGING: 'tagging',
  QUESTIONNAIRE: 'questionnaire',
  HOOKS: 'hooks',
  ACTIONS: 'actions',
  SELECTORS: 'selectors',
  REDUCERS: 'reducers',
  SAGAS: 'sagas',
  SERVICES: 'services',
  UTILS: 'utils',
  COMPONENTS: 'components'
};
// Variables
Logger.levels = ['info', 'warn', 'error'];
Logger.segments = [...Object.values(Logger.LOGGER_SEGMENTS)];
// Methods
Logger.setLevels = function () {
  let levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  Logger.levels = levels;
};
Logger.setSegments = function () {
  let segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  Logger.segments = segments;
};
Logger.loggingFunction = function (level) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  //This method can be extended to log to a file, a database, etc.
  //Additionally a setter for the logging channel can be implemented
  console[level](`%c[${(0, _utils.capitalize)(level)}]`, `color: ${Logger.levelColors[level]}`, ...args);
};
Logger.info = _ref => {
  let {
    segments
  } = _ref;
  return function () {
    Logger.log({
      segments,
      level: 'info'
    })(...arguments);
  };
};
Logger.warn = _ref2 => {
  let {
    segments
  } = _ref2;
  return function () {
    Logger.log({
      segments,
      level: 'warn'
    })(...arguments);
  };
};
Logger.error = _ref3 => {
  let {
    segments
  } = _ref3;
  return function () {
    Logger.log({
      segments,
      level: 'error'
    })(...arguments);
  };
};
Logger.log = _ref4 => {
  let {
    segments = [],
    level = 'info'
  } = _ref4;
  return function () {
    if (Logger.levels.includes(level) && Logger.segments.some(segment => segments.includes(segment))) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      Logger.loggingFunction(level, ...args);
    }
  };
};